import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { createAuthGuard, AuthGuardData } from 'keycloak-angular';
import { UrlTree, CanActivateFn } from '@angular/router';
import Keycloak from 'keycloak-js';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;

  console.log('route', route);
  const requiredRoles = route.data['roles'];
  console.log('requiredRoles', requiredRoles);
  if (!requiredRoles) {
    return false;
  }

  const hasRequiredRole = (role: string): boolean =>
    Object.values(grantedRoles.realmRoles).some((roles) => roles.includes(role));

  console.log('grantedRoles', grantedRoles);
  console.log('authenticated', authenticated);
  if (!authenticated) {
    await inject(Keycloak).login({
      redirectUri: window.location.href
    })
  }

  if (authenticated && hasRequiredRole(requiredRoles)) {
    return true;
  }

  const router = inject(Router);
  return router.parseUrl('/page-forbidden');
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);
